(function () {
  const SELECTOR = '[data-lse-registration]';

  function todayAsLocalIsoDate() {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60000;
    return new Date(now.getTime() - offset).toISOString().slice(0, 10);
  }

  function fieldValue(form, selector) {
    const field = form.querySelector(selector);
    return field ? field.value.trim() : '';
  }

  function selectedValue(form, name) {
    const field = form.querySelector(`input[name="${name}"]:checked`);
    return field ? field.value : '';
  }

  function buildEmailSummary(form) {
    const diagnosis = fieldValue(form, '[data-lse-diagnosis]');
    const otherDiagnosis = fieldValue(form, '[data-lse-other-diagnosis]');
    const diagnosisText = diagnosis === 'Other' ? `Other: ${otherDiagnosis}` : diagnosis;

    return [
      'LSE FAMILY REGISTRATION',
      '',
      `Relationship to child: ${fieldValue(form, '[name="contact[Relationship to child]"]')}`,
      `Parent/guardian name: ${fieldValue(form, '[name="contact[first_name]"]')} ${fieldValue(form, '[name="contact[last_name]"]')}`,
      `Lives in Australia: ${selectedValue(form, 'contact[Lives in Australia]')}`,
      `Email: ${fieldValue(form, '[name="contact[email]"]')}`,
      `Mobile: ${fieldValue(form, '[name="contact[phone]"]')}`,
      '',
      `Child's name: ${fieldValue(form, '[name="contact[Child name]"]')}`,
      `Child's date of birth: ${fieldValue(form, '[name="contact[Child date of birth]"]')}`,
      `Child's diagnosis: ${diagnosisText}`,
      `Year diagnosed: ${fieldValue(form, '[name="contact[Year diagnosed]"]')}`,
      '',
      'Postal address:',
      fieldValue(form, '[name="contact[Address line 1]"]'),
      fieldValue(form, '[name="contact[Address line 2]"]'),
      `${fieldValue(form, '[name="contact[Suburb]"]')} ${fieldValue(form, '[name="contact[State or territory]"]')} ${fieldValue(form, '[name="contact[Postcode]"]')}`,
      'Australia',
      '',
      'Customer tag: lse-registration',
    ]
      .filter((line, index, lines) => line !== '' || lines[index - 1] !== '')
      .join('\n');
  }

  function setEligibility(root) {
    const form = root.querySelector('.lse-registration__form');
    const fields = root.querySelector('[data-lse-fields]');
    const error = root.querySelector('[data-lse-eligibility-error]');
    const selected = selectedValue(form, 'contact[Lives in Australia]');
    const isIneligible = selected === 'No';

    fields.disabled = isIneligible;
    error.hidden = !isIneligible;

    if (isIneligible) {
      error.focus();
    }
  }

  function setOtherDiagnosis(root) {
    const diagnosis = root.querySelector('[data-lse-diagnosis]');
    const wrapper = root.querySelector('[data-lse-other-wrapper]');
    const input = root.querySelector('[data-lse-other-diagnosis]');
    const isOther = diagnosis.value === 'Other';

    wrapper.hidden = !isOther;
    input.disabled = !isOther;
    input.required = isOther;

    if (!isOther) {
      input.value = '';
    }
  }

  async function createOrTagCustomer(root, form) {
    const customerForm = root.querySelector('.lse-registration__customer-form');
    const customerData = new FormData(customerForm);

    customerData.set('contact[email]', fieldValue(form, '[name="contact[email]"]'));
    customerData.set('contact[first_name]', fieldValue(form, '[name="contact[first_name]"]'));
    customerData.set('contact[last_name]', fieldValue(form, '[name="contact[last_name]"]'));
    customerData.set('contact[phone]', fieldValue(form, '[name="contact[phone]"]'));
    customerData.set('contact[tags]', 'lse-registration');

    const response = await fetch(customerForm.action, {
      method: 'POST',
      body: customerData,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error(`Customer request failed with status ${response.status}`);
    }

    const responseUrl = new URL(response.url, window.location.origin);
    const saved = responseUrl.searchParams.get('lse_customer_posted') === '1';

    if (!saved) {
      throw new Error('Shopify did not confirm the customer record');
    }
  }

  function init(root) {
    if (root.dataset.lseInitialized === 'true') return;

    const form = root.querySelector('.lse-registration__form');
    if (!form) return;

    root.dataset.lseInitialized = 'true';

    const eligibilityInputs = root.querySelectorAll('[data-lse-eligibility]');
    if (eligibilityInputs.length === 0) return;
    const diagnosis = root.querySelector('[data-lse-diagnosis]');
    const dob = root.querySelector('[data-lse-dob]');
    const diagnosedYear = root.querySelector('[data-lse-year-diagnosed]');
    const body = root.querySelector('[data-lse-email-body]');
    const button = root.querySelector('[data-lse-submit]');
    const buttonLabel = root.querySelector('[data-lse-submit-label]');
    const saveStatus = root.querySelector('[data-lse-save-status]');
    const saveError = root.querySelector('[data-lse-save-error]');
    const defaultButtonText = buttonLabel.textContent;
    let saving = false;
    let submitting = false;

    dob.max = todayAsLocalIsoDate();
    diagnosedYear.max = String(new Date().getFullYear());

    eligibilityInputs.forEach((input) => {
      input.addEventListener('change', () => setEligibility(root));
    });
    diagnosis.addEventListener('change', () => setOtherDiagnosis(root));

    setEligibility(root);
    setOtherDiagnosis(root);

    form.addEventListener('submit', async (event) => {
      if (submitting) return;

      event.preventDefault();
      if (saving) return;

      saveError.hidden = true;

      const eligibility = selectedValue(form, 'contact[Lives in Australia]');
      if (eligibility !== 'Yes') {
        if (eligibility === 'No') {
          setEligibility(root);
        } else {
          form.querySelector('[data-lse-eligibility]').focus();
        }
        form.reportValidity();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      body.value = buildEmailSummary(form);
      saving = true;
      button.disabled = true;
      buttonLabel.textContent = root.dataset.savingLabel;
      saveStatus.textContent = root.dataset.savingMessage;

      try {
        await createOrTagCustomer(root, form);
        submitting = true;
        saveStatus.textContent = root.dataset.sendingMessage;
        buttonLabel.textContent = root.dataset.sendingLabel;
        form.submit();
      } catch (error) {
        console.error('LSE registration customer save failed', error);
        saving = false;
        button.disabled = false;
        buttonLabel.textContent = defaultButtonText;
        saveStatus.textContent = '';
        saveError.hidden = false;
        saveError.focus();
      }
    });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches(SELECTOR)) init(scope);
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
